// this is the start of the app portion of the program.
// starts when an image is uploaded and runs through all nessesary child components to stereo Animate

// imports
import React from 'react'; // react library
import Button from '@material-ui/core/Button'; // button from material UI
import { CropWindow } from './CropWindow.js'; // crop window component for app starting


//Start app Component
export class StartApp extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            window: false,
            selectedFile: null,
        }
        //bind functions
        this.onChangeHandler = this.onChangeHandler.bind(this);
        this.exitHandler = this.exitHandler.bind(this);
    }

    // handles change of file to state
    onChangeHandler = event => {
        console.log(event.target.files[0])
        this.setState({
            selectedFile: URL.createObjectURL(event.target.files[0]),
            window: true,
        })   

    }

    //function to pass to child component for exit button and reset
    exitHandler = e => {
        this.setState({
            window: false,
            selectedFile: '',
        });
    }
    render() {
        return  <div>
                    {
                        //setup for upload button and instructions
                    }
                    <div>
                        <h2 className='appText'>Welcome to the App</h2>
                        <h3 className="instructions">Instructions</h3>
                        <ol className="instructions">
                            <li>Download a Stereoscopic Image from the Web (see the collection linked below)</li>
                            <li>Upload the Image to the App</li>
                            <li>The app dialog will open with two crop windows.</li>
                            <li>Adjust the Placement of the Image in Each Window using the Tools Provided.</li>
                            <li>Select "Stereo-Animate"</li>
                            <li>Wait for the gif to load and view the preview.</li>
                            <li>Change the speed of the image switch as desired</li>
                            <li><strong>Note:</strong> Images have been found to be best animated when viewed sitting a normal distance from your screen</li>
                            <p className="mountainscholar link">A collection of Stereoscopic images may be found at the <a href="https://mountainscholar.org/handle/20.500.11919/3844" target="_blank">Mountain Scholar Website</a>.</p>
                        </ol>
                    </div>
                    <form>
                        <input type='file' name='file' onChange={this.onChangeHandler} className='hidden' onClick="this.form.reset()" id="Upload-Button"/>
                        <label htmlFor="Upload-Button">
                                <Button variant="outlined"  component="span" id='Upload'>
                                Upload Image
                                </Button>
                        </label>
                    </form>
                    {this.state.window && <CropWindow image={this.state.selectedFile} exit={this.exitHandler} changeImage= {this.onChangeHandler}/> }
                </div>
    }
}